import React, { createContext, useMemo, useState } from 'react';

import PropTypes from 'prop-types';

export const QrScannerContext = createContext({});

export const QrScannerContextProvider = ({ children }) => {
  const [qrScannerOpen, setQrScannerOpen] = useState(false);

  const value = useMemo(
    () => ({ qrScannerOpen, setQrScannerOpen }),
    [qrScannerOpen, setQrScannerOpen]
  );

  return <QrScannerContext.Provider value={value}>{children}</QrScannerContext.Provider>;
};

QrScannerContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
